import React from 'react';
import { elementType } from 'prop-types';
import GympassLogo from './GympassLogo';

var Logo = function Logo(_ref) {
  var CustomLogo = _ref.customLogo;
  return CustomLogo ? /*#__PURE__*/React.createElement(CustomLogo, null) : /*#__PURE__*/React.createElement(GympassLogo, null);
};

Logo.propTypes = {
  customLogo: elementType
};
Logo.defaultProps = {
  customLogo: null
};
export default Logo;